import { ACTION_TYPE } from './action';

const mailTemplates = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_INIT_MAIL_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        selects: action.selects,
      };
    case ACTION_TYPE.CALL_API_MAIL_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        datas: action.datas,
      };
    case ACTION_TYPE.SET_SEARCH_MAIL_TEMPLATES:
      return {
        ...state,
        searchCondition: action.searchCondition,
      };
    case ACTION_TYPE.CALL_API_DELETE_MAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        isDeleteSuccess: true,
      };
    case ACTION_TYPE.CALL_API_GET_MAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    case ACTION_TYPE.CALL_API_SAVE_MAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        saveId: action.saveId,
        isSaveSuccess: true,
      };
    case ACTION_TYPE.RESET_MAIL_TEMPLATE_FLG:
      return {
        ...state,
        isDeleteSuccess: false,
        isSaveSuccess: false,
      };
    default:
      return state;
  }
};

export default mailTemplates;
